import { defineComponent } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import Widget from '../Widget/Widget';
import { WidgetTypes } from 'interfaces';
import BannerCheckMatch from './BannerCheckMatch/BannerCheckMatch.vue';
import BannerFinal from './BannerFinal/BannerFinal.vue';

export default defineComponent({
	components: {
		BannerCheckMatch,
		BannerFinal,
	},
	props: {
		studyId: Number,
		widgetType: String,
		widgetLocation: String,
		emptyText: String,
	},
	setup: (props) => {
		const studyId = props.studyId as number;
		const widgetType = props.widgetType as WidgetTypes;
		const widgetLocation = props.widgetLocation as string;
		const emptyText = props.emptyText as string;

		const codeBehind = new Widget(
			studyId,
			widgetType,
			widgetLocation,
			emptyText,
		);

		return setupComponent(codeBehind);
	},
});
